import { faObjectGroup } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  FontSizeProperty,
  FontWeightProperty,
  MarginProperty,
  PaddingProperty,
  VisibilityRulesProperty,
} from "../PropertyTypes/Properties";

export const Section = {
  type: "Section",
  properties: [
    FontSizeProperty,
    FontWeightProperty,
    PaddingProperty,
    MarginProperty,
    VisibilityRulesProperty,
  ],
  icon: () => {
    return (
      <FontAwesomeIcon
        className="k-vertical-align-center k-mr-2"
        icon={faObjectGroup}
        fontSize={18}
      />
    );
  },
};
